export const withBasicIdentities = ({
	id = '',
	name = '',
	label = '',
}) => ({
	id, name, label,
});
